import type { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Renders a page in the CIPD "Claude design" style — a purple gradient hero
 * (eyebrow + title + subtitle) above a themed content card — matching the Azure
 * design pages. Pass `markdown` to render a .md file in the themed content, or
 * `children` for custom content (e.g. the Site hub cards). Content stays as
 * markdown so it's easy to keep current; the shell provides the professional look.
 */
export default function DesignShell({
  eyebrow = 'Synergy Platform · Site',
  title,
  subtitle,
  markdown,
  children,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  markdown?: string;
  children?: ReactNode;
}) {
  return (
    <div className="page design-page">
      <header className="design-hero">
        <p className="design-eyebrow">{eyebrow}</p>
        <h1 className="design-title">{title}</h1>
        {subtitle && <p className="design-subtitle">{subtitle}</p>}
      </header>
      <div className="design-content">
        {markdown ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
